import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkAlert',
  props: {
    emoji: null,
    text: null,
    title: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})